export default __webpack_public_path__ + "static/2-db7c876f11b3e35d01ae2271fcf4b411.png";